<aside class="left-sidebar with-vertical">
    <div class="brand-logo d-flex align-items-center justify-content-between">
        <a href="/" class="text-nowrap logo-img">
            <img src="/assets/img/logo-horizontal.svg" alt="TmplVision" style="max-width: 160px; height: auto;" />
        </a>
        <a href="javascript:void(0)" class="sidebartoggler ms-auto text-decoration-none fs-5 d-block d-xl-none">
            <i class="ti ti-x"></i>
        </a>
    </div>
    <nav class="sidebar-nav scroll-sidebar" data-simplebar>
        <ul id="sidebarnav">
            <li class="nav-small-cap">
                <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
                <span class="hide-menu">Home</span>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:home-2-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Dashboard</span>
                </a>
            </li>

            <li class="nav-small-cap">
                <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
                <span class="hide-menu">Work</span>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/template/list" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:document-text-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Templates</span>
                </a>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/pack/list" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:box-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Packs</span>
                </a>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/help" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:question-circle-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Help</span>
                </a>
            </li>


            <li class="nav-small-cap">
                <i class="ti ti-dots nav-small-cap-icon fs-4"></i>
                <span class="hide-menu">Admin</span>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/settings" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:settings-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Settings</span>
                </a>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/api-tokens" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:key-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">API Tokens</span>
                </a>
            </li>
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/premium" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:crown-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Premium</span>
                </a>
            </li>
            <!--
            <li class="sidebar-item">
                <a class="sidebar-link sidebar-link primary-hover-bg" href="/logs" aria-expanded="false">
                    <span class="aside-icon p-2 bg-primary-subtle rounded-1">
                      <iconify-icon icon="solar:clipboard-list-line-duotone" class="fs-6"></iconify-icon>
                    </span>
                    <span class="hide-menu ps-1">Logs</span>
                </a>
            </li>
            -->
        </ul>
    </nav>
    <!--
    <div class="fixed-profile mx-3 mt-3">
        <div class="card bg-primary-subtle mb-0 shadow-none">
            <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center gap-3">
                        <img src="@@webRoot/assets/images/profile/user-1.jpg" width="45" height="45" class="img-fluid rounded-circle" alt="spike-img" />
                        <div>
                            <h5 class="mb-1">Mike</h5>
                            <p class="mb-0">Admin</p>
                        </div>
                    </div>
                    <a href="javascript:void(0)" class="position-relative" data-bs-toggle="tooltip" data-bs-placement="top"
                       data-bs-title="Logout">
                        <iconify-icon icon="solar:logout-line-duotone" class="fs-8"></iconify-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    -->
</aside>
